module.exports = __webpack_public_path__ + "img/2C.c9a6af1a.png";